import React from "react";
import { observer } from "mobx-react";
import { ShowcaseWorkflowStateUpdateStore } from "../../store";
import { ShowcaseWorkflowStateUpdateForm } from "./ShowcaseWorkflowStateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ShowcaseWorkflowStateUpdateProps = {
  showcaseWorkflowStateUpdateStore: ShowcaseWorkflowStateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseWorkflowStateUpdate: React.FC<ShowcaseWorkflowStateUpdateProps> =
  observer(
    ({
      showcaseWorkflowStateUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={showcaseWorkflowStateUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={showcaseWorkflowStateUpdateStore.savedButOutdated}
            onReload={() =>
              showcaseWorkflowStateUpdateStore.reloadShowcaseWorkflowState()
            }
            reloadDisabled={showcaseWorkflowStateUpdateStore.isProcessing}
          />
          <ShowcaseWorkflowStateUpdateForm
            showcaseWorkflowStateUpdateStore={showcaseWorkflowStateUpdateStore}
            name_esError={
              showcaseWorkflowStateUpdateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              showcaseWorkflowStateUpdateStore.setName_esValue(value);
            }}
            name_es={showcaseWorkflowStateUpdateStore.entityValues.name_es}
            name_enError={
              showcaseWorkflowStateUpdateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              showcaseWorkflowStateUpdateStore.setName_enValue(value);
            }}
            name_en={showcaseWorkflowStateUpdateStore.entityValues.name_en}
            name_ptError={
              showcaseWorkflowStateUpdateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              showcaseWorkflowStateUpdateStore.setName_ptValue(value);
            }}
            name_pt={showcaseWorkflowStateUpdateStore.entityValues.name_pt}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={showcaseWorkflowStateUpdateStore.saveDisabled}
            onSave={() =>
              showcaseWorkflowStateUpdateStore.saveShowcaseWorkflowState()
            }
            onCancel={() =>
              showcaseWorkflowStateUpdateStore.cancelShowcaseWorkflowState()
            }
          />
          <ErrorDialog
            open={showcaseWorkflowStateUpdateStore.errorDialogOpened}
            title={showcaseWorkflowStateUpdateStore.errorTitle}
            description={showcaseWorkflowStateUpdateStore.errorDescription}
            onClose={() => showcaseWorkflowStateUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={showcaseWorkflowStateUpdateStore.confirmDialogOpened}
            title={showcaseWorkflowStateUpdateStore.confirmDialogTitle}
            description={
              showcaseWorkflowStateUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              showcaseWorkflowStateUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              showcaseWorkflowStateUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
